import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SetupApprovalPage } from './setup-approval.page';

const routes: Routes = [
  {
    path: '',
    component: SetupApprovalPage
  },
  {
    path: 'setup-approval-edit',
    loadChildren: () => import('./setup-approval-edit/setup-approval-edit.module').then( m => m.SetupApprovalEditPageModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SetupApprovalPageRoutingModule {}
